import React from "react";
import { Field, ErrorMessage } from "formik";

const InputField = ({ label, name, type = "text", ...rest }) => {
  return (
    <div className="mb-4">
      <label htmlFor={name} className="block text-gray-700 text-sm font-bold mb-2">
        {label}
      </label>
      <Field
        id={name}
        name={name}
        type={type}
        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none
         focus:shadow-outline focus:border-blue-500"
        {...rest}
      />
      <ErrorMessage name={name} component="div" className="text-red-500 text-sm" />
    </div>
  );
};

export default InputField;
